import {
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
} from 'firebase/firestore';
import { db } from './firebase';

export const createUserProfile = async (userId, userData) => {
  try {
    await setDoc(doc(db, 'users', userId), {
      uid: userId,
      email: userData.email || '',
      name: userData.name || '',
      photoURL: userData.photoURL || '',
      bodyShape: null,
      bodyShapeName: null,
      bodyGender: null,
      bodyTopSize: null,
      bodyBottomSize: null,
      bodySize: null,
      budgetRange: null,
      preferredStyles: [],
      wishlist: [],
      searchHistory: [],
      createdAt: new Date().toISOString(),
      lastLogin: new Date().toISOString(),
    });
  } catch (error) {
    console.error('Error creating user profile:', error);
  }
};

export const updateLastLogin = async (userId) => {
  try {
    await updateDoc(doc(db, 'users', userId), {
      lastLogin: new Date().toISOString(),
    });
  } catch (error) {
    console.error('Error updating last login:', error);
  }
};

export const saveBodyProfile = async (userId, profile) => {
  try {
    await updateDoc(doc(db, 'users', userId), {
      bodyShape: profile.shape,
      bodyShapeName: profile.shapeName,
      bodyGender: profile.gender,
      bodySize: profile.topSize || profile.size,
      bodyTopSize: profile.topSize || profile.size,
      bodyBottomSize: profile.bottomSize || null,
      bodyUpdatedAt: new Date().toISOString(),
    });
    console.log('Body profile saved:', profile);
  } catch (error) {
    console.error('Error saving body profile:', error);
  }
};

export const getBodyProfile = async (userId) => {
  try {
    const docRef = doc(db, 'users', userId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      if (data.bodyShape) {
        return {
          shape: data.bodyShape,
          shapeName: data.bodyShapeName,
          gender: data.bodyGender,
          size: data.bodyTopSize || data.bodySize,
          topSize: data.bodyTopSize || data.bodySize,
          bottomSize: data.bodyBottomSize || null,
        };
      }
    }
    return null;
  } catch (error) {
    console.error('Error getting body profile:', error);
    return null;
  }
};

export const saveSearchHistory = async (userId, query) => {
  try {
    await updateDoc(doc(db, 'users', userId), {
      searchHistory: arrayUnion({
        query,
        timestamp: new Date().toISOString(),
      }),
    });
  } catch (error) {
    console.error('Error saving search history:', error);
  }
};